import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { UserAccountsEntity } from './user-accounts.models'

@Injectable({
  providedIn: 'root',
})
export class UserAccountsApiService extends GbApiService {
  loadUserAccounts(
    offset: number,
    searchTerm: string | undefined,
    searchBy: string | undefined,
    ordering: string,
  ): Observable<GbPaginatedResponse<UserAccountsEntity>> {
    let params = new HttpParams()
      .set('offset', offset)
      .set('limit', this.appConfig.itemsPageSize)
      .set('ordering', ordering)

    if (searchTerm) {
      params = params.set('search', searchTerm)
      if (searchBy) {
        params = params.set('search_by', searchBy)
      }
    }

    const url = 'users/'
    return this.get<GbPaginatedResponse<UserAccountsEntity>>(url, { params })
  }

  archiveUser(uuid = ''): Observable<UserAccountsEntity> {
    const url = `users/${uuid}/anonymise/`
    return this.post<UserAccountsEntity>(url)
  }

  removeFromUnsubscribeList(uuid = ''): Observable<void> {
    const url = `users/${uuid}/remove-from-unsubscribe-list/`
    return this.post<void>(url)
  }
}
